import axios from 'axios';
import { auth } from './firebase';
import { logout } from '../redux/slice/Authslice';
import store from '../redux/store'

// ─── Create Axios Instance ────────────────────────────────────────────────────
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.theoutletapp.com',
    timeout: 30000, // 30 seconds
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// ─── Request Interceptor ──────────────────────────────────────────────────────
api.interceptors.request.use(
    async (config) => {
        try {
            // Get current Firebase user
            const currentUser = auth.currentUser;

            if (currentUser) {
                // Get fresh Firebase ID token
                const token = await currentUser.getIdToken(false); // false = use cached token
                
                // Attach token to request headers
                config.headers.Authorization = `Bearer ${token}`;
            }
        } catch (error) {
            console.error('Error getting auth token:', error);
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// ─── Response Interceptor ─────────────────────────────────────────────────────
api.interceptors.response.use(
    (response) => {
        // Return response data directly
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // Handle 401 Unauthorized
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const currentUser = auth.currentUser;

                if (currentUser) {
                    // Force refresh the token
                    const newToken = await currentUser.getIdToken(true);
                    
                    // Update request header with new token
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                    
                    // Retry the original request
                    return api(originalRequest);
                }
            } catch (refreshError) {
                // Token refresh failed - logout user
                console.error('Token refresh failed:', refreshError);
                store.dispatch(logout());
                window.location.href = '/login';
            }
        }

        // Handle 403 Forbidden
        // if (error.response?.status === 403) {
        //     console.error('Access forbidden:', error.response.data);
        //     store.dispatch(logout());
        //     window.location.href = '/login';
        // }

        // Handle 500 Server Error
        if (error.response?.status >= 500) {
            console.error('Server error:', error.response.data);
        }

        // Handle Network Error (no internet)
        if (!error.response) {
            console.error('Network error - no internet connection');
        }

        return Promise.reject(error);
    }
);

export default api;